import { useEffect ,useRef } from 'react'
import AOS from 'aos'
import Button from '@ui/Button'
import MetaInfo from '@/components/common/MetaInfo'
import Breadcrumb from '@common/Breadcrumb'
import TransformBanner from '@sections/TransformBanner'
import { ROUTES,SITE } from '@/constants'
import { useScrollStack } from '../assets/js/common'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.PRODUCT_EXPERIENCE_DESIGN)


// Section 1 — what the design approach delivers
const APPROACH_DELIVERABLES = [
  { icon: 'fa-layer-group',   title: 'Consistent experiences across platforms', desc: 'Maintain a unified design language and seamless user experience across web, mobile, SaaS, and other digital touchpoints.' },
  { icon: 'fa-cubes',         title: 'Scalable product foundations',            desc: 'Build flexible design structures and reusable components that make future enhancements faster and more cost-effective.' },
  { icon: 'fa-arrows-rotate', title: 'Faster feedback and iteration',           desc: 'Validate ideas early, incorporate user feedback efficiently, and continuously improve the product experience.' },
  { icon: 'fa-flask',         title: 'Rapid experimentation and validation',    desc: 'Explore new concepts through prototypes and usability testing before committing significant development resources.' },
]

// Section 3 — business outcomes
const BUSINESS_OUTCOMES = [
  { id: 1, icon: 'fa-chart-line',title: 'Increase User Engagement', desc: 'Create experiences that encourage users to interact, explore, and return. Through thoughtful interactions, relevant content, personalization, and purposeful engagement mechanisms, we help digital products become more useful and compelling.' ,tags: ['Industries', 'Domain'], image: '/assets/images/stories/banner1.png', link: '#' },
  { id: 2, icon: 'fa-list-check',title: 'Improve Usability and Task Completion',      desc: 'Simplify complex workflows and make important actions easier to discover and complete. Clear information architecture, intuitive navigation, and well-designed interfaces reduce friction and help users accomplish their objectives with confidence.' ,    tags: ['Industries', 'Domain'], image: '/assets/images/stories/numindconsultancy.jpg', link: 'https://numindconsultancy.com/' },
  { id: 3,icon: 'fa-rocket', title: 'Accelerate User Onboarding',      desc: 'Help new users understand your product faster with guided experiences, contextual assistance, progressive disclosure, and intuitive workflows. A well-designed onboarding experience can reduce the learning curve and improve early product adoption.',tags: ['Industries', 'Domain'], image: '/assets/images/stories/jj_academy.jpg', link: 'https://www.jjacademy.in/' },
  { id: 4, icon: 'fa-user-gear', title: 'Deliver Meaningful Personalization',desc: 'Design experiences that adapt to user preferences, behavior, and context. From personalized recommendations to saved preferences and relevant content, thoughtful personalization can make digital products feel more useful and relevant.' ,tags: ['Industries', 'Domain'], image: '/assets/images/stories/delp1.jpg', link: '#' },
  { id: 5,icon: 'fa-gears',    title: 'Reduce Product Development Friction',desc: 'A well-defined design system, validated user flows, and clear product specifications help development teams work more efficiently. Identifying design issues before development reduces rework and eases future product changes.' ,tags: ['Industries', 'Domain'], image: '/assets/images/stories/praapti.jpg', link: 'https://praapti.in/' },
  { id: 6,  icon: 'fa-sitemap',title: 'Build Products That Scale',desc: 'Design with the future in mind. Reusable components, scalable design systems, consistent interaction patterns, and flexible user flows create a strong foundation for expanding features, platforms, and user bases.' ,tags: ['Industries', 'Domain'], image: '/assets/images/stories/posoco1.jpg', link: 'http://vidyutpravah.in/' },
  
]
// function useScrollStack(containerRef, count) {
  
//   useEffect(() => {
//     const container = containerRef.current
//     if (!container) return
//     const cards = Array.from(container.querySelectorAll('.ss-card'))

//     // The sticky "stacked deck" illusion only exists at >=992px (see the
//     // matching @media (max-width: 991px) rule in main.css that turns off
//     // position:sticky on .ss-card). Below that, this effect must not run
//     // at all — otherwise cards visibly shrink/shift on every scroll even
//     // though there's no stack to sell the illusion for.
//     const mql = window.matchMedia('(min-width: 992px)')

//     const clearTransforms = () => {
//       cards.forEach((card) => { card.style.transform = '' })
//     }

//     const onScroll = () => {
//       if (!mql.matches) return
//       const top  = container.getBoundingClientRect().top
//       const h    = container.offsetHeight
//       const winH = window.innerHeight
//       cards.forEach((card, i) => {
//         const progress = Math.max(0, Math.min(1, (-top + i * (winH * 0.3)) / (h - winH)))
//         if (progress >= 1) {
//           card.style.transform = 'scale(0.94) translateY(-24px)'
//         } else if (progress > 0) {
//           card.style.transform = `scale(${1 - progress * 0.06}) translateY(${-(progress * 24)}px)`
//         } else {
//           card.style.transform = 'scale(1) translateY(0)'
//         }
//       })
//     }

//     const onBreakpointChange = () => {
//       if (!mql.matches) clearTransforms()
//       onScroll()
//     }

//     window.addEventListener('scroll', onScroll, { passive: true })
//     window.addEventListener('resize', onBreakpointChange)
//     // Safari <14 only supports the older addListener/removeListener API.
//     if (mql.addEventListener) mql.addEventListener('change', onBreakpointChange)
//     else mql.addListener(onBreakpointChange)
//     onBreakpointChange()

//     return () => {
//       window.removeEventListener('scroll', onScroll)
//       window.removeEventListener('resize', onBreakpointChange)
//       if (mql.removeEventListener) mql.removeEventListener('change', onBreakpointChange)
//       else mql.removeListener(onBreakpointChange)
//     }
//   }, [containerRef, count])
// }
export default function ProductExperienceDesign() {
   const stackRef   = useRef(null)
    useScrollStack(stackRef, BUSINESS_OUTCOMES.length)
 // useEffect(() => { AOS.refresh(); window.scrollTo(0, 0) }, [])

  return (
    <>
      {/* <MetaInfo
        title="Product Experience Design Services | CruxBytes"
        description="CruxBytes designs digital product experiences that unite user needs, business goals, and technology — helping products become easier to use, faster to evolve, and built to scale."
        keywords="Product Experience Design, digital product design, user experience design company, product design consulting, UX strategy"
      /> */}
       <MetaInfo
     title={label}
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
        <div className="page-hero">
          <div className="bg-grid bg-grid--fill" aria-hidden="true" />
          <div className="container">
            <Breadcrumb />
            <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* Product Experience Design */}
              {label}
              </h1>
            <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
              {/* Design digital products that are simple, intuitive, consistent, and positioned for long-term growth. */}
              {pageDesc}
            </p>

            <div className="inner-page-actions">
              <Button href={ROUTES.SALES_ENQUIRY} variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                Get a Free Quote
              </Button>
            </div>
          </div>
        </div>
                {/* ── Section 1: Intro + what the approach delivers ── */}
<section className="bg-linear-gradient-light section-py" aria-labelledby="sc-tm-heading">
  <div className="container">
    <div className="sc-tm-row">

      <div className="sc-tm-content" data-aos="fade-left">
         <h2 id="sc-tm-heading" className="sc-tm-heading">
          What Our Digital Product Design Approach Delivers
        </h2>
        <p>
           Great digital products are built around experiences that are simple, intuitive, consistent, and purposeful. From the first interaction to everyday usage, every touchpoint influences how users perceive your product and your brand.
        </p>
        <p>
           At CruxBytes, we design digital product experiences that bring together end-user needs, business objectives, technology, and usability. Our approach helps organizations create products that are easier to use, faster to evolve, and better positioned for long-term growth.
        </p>
      </div>
      <div  data-aos="fade-right">
        <div className="deliverables-card">
          <div className="deliverables-grid">
    {APPROACH_DELIVERABLES.map((item, i) => (
      <div key={item.title} className="deliverable-item" data-aos="fade-up" data-aos-delay={i * 70}>
        
        <h6 className="deliverable-title">{item.title}</h6>
        <p className="deliverable-desc">{item.desc}</p>
      </div>
    ))}
  </div>
        </div>
      </div>

      
   

    </div>
  </div>
</section>

   

        {/* ── Section 2: From ideas to meaningful product experiences ── */}
         <section className="bgs-section bgs-section--tint section-py" aria-labelledby="bgs-reach-heading">
      <div className="container">
        <div className="text-align-center" data-aos="fade-up">
          <h2 id="bgs-reach-heading">
           From Ideas to Meaningful Product Experiences
          </h2>
        </div>     

        {/* Row 2 — Email marketing (text-only, no reference image) */}
        <div className="bgs-row bgs-row--text-only" data-aos="fade-up">
          <div className="bgs-row-content">
          
            <p style={{color: 'var(--bg-primary)'}}>
               We combine design thinking, user research, industry expertise, and technology understanding
                to transform ideas into practical digital experiences. Our team brings together UX
                strategists, designers, and technology professionals who collaborate throughout the product
                lifecycle.
            </p>
            <p style={{color: 'var(--bg-primary)'}}>
                Whether you are launching a new digital product or improving an existing application, we
                consider the complete experience — from user expectations and workflows to interface design
                and technical feasibility. This helps ensure a consistent experience across every relevant
                customer and user touchpoint.
            </p>
            <div className="inner-page-actions">
                <Button href={ROUTES.SALES_ENQUIRY} variant="primary" icon="fa-arrow-right" iconPos="right">
                  Get a Free Quote
                </Button>
              </div>
          </div>
        </div>

      </div>
    </section>
       {/* ── Section 3: Business outcomes of better product design ── */}
<section className="section-py" aria-labelledby="pux-outcomes-heading">
  <div className="container">
    <div className="sc-tm-row sc-tm-row--sticky-heading">

      <div className="sc-tm-content" data-aos="fade-left">
         <h2 id="pux-outcomes-heading" >
        Business Outcomes of Better Product Design
        </h2>
     
      </div>
      <div  data-aos="fade-right">
        <div className="ss-cards-panel" ref={stackRef}>
                {BUSINESS_OUTCOMES.map((story, idx) => (
                  <article
                    key={story.id}
                    className="ss-card"
                    style={{ '--card-index': idx }}
                    aria-label={story.title}
                  >
                    {/* Left — text */}
                    <div className="ss-card-text">
                      <span className="icon-circle" aria-hidden="true">
                       <i className={`fa-solid ${story.icon}`} /></span>
                      <h3 className="ss-card-title">{story.title}</h3>
                      <p className="ss-card-desc">{story.desc}</p>                    
                     
                    </div>                   
                  </article>
                ))}
              </div>
      </div>

    </div>
  </div>
</section>
        
        

        <TransformBanner />
      </main>
    </>
  )
}